import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {SessionService} from '../../services/session.service';
import * as $ from 'jquery';
import {environment} from '../../../environments/environment';
import {PlatformLocation} from '@angular/common';
import { AdminUserI } from '../../interfaces/admin/admin-user.interface';
// import {GeolocationService} from '../../services/geolocation.service';
// import {UserLogsService} from '../../services/user-logs.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  // region Attributes
  public title = 'Login Page';
  public user: AdminUserI;
  public token: any;

  public status: string;
  public message_success: string;
  public spinner = false;
  private API_URL = environment.url;

  arrayErrors = [];
  // endregion

  // region Constructor
  constructor(

    private router: Router,
    public userService: SessionService,
    public route: ActivatedRoute,
    private platformLocation: PlatformLocation,
    // private geolocation: GeolocationService,
    // private logs: UserLogsService,
  ) {
    this.user = {
      username: null,
      password: null
    };
    this.token = this.userService.getToken();
    if (this.token) {
      this.router.navigate(['/users/list']);
    }
  }
  // endregion

  //region Métodos
  ngOnInit(): void {

  }

  //Método para iniciar sesión
  singUp() {
    if (this.user.password === '' || this.user.username === '') {
      this.status = 'error';
      this.arrayErrors = ['Verifica que todos los campos esten correctamente llenados'];
      this.durationMessage('login');
      return;
    }
    this.spinner = true;
    const data = {
      username: String(this.user.username).trim(),
      password: String(this.user.password).trim()
    };

    setTimeout(() => {
      this.userService.signup(data).subscribe(async (res) => {

        this.spinner = false;
        $('.login').show();
        if (res.ok === true) {
          this.status = 'success';
          this.message_success = 'Bienvenido de nuevo';

          this.token = res.token;
          sessionStorage.setItem(this.userService.JWToken, this.token);

          this.router.navigate(['/users/list']);
        }
      }, async (error) => {
        this.spinner = false;
        $('.login').show();
        this.status = 'error';
        if (error.status === 0) {
          this.arrayErrors = ['Cannot start connection to server at the moment'];
          this.durationMessage('login');
        } else {
          this.status = 'error';
          this.arrayErrors = [error.error.errors];
          this.durationMessage('login');
        }
      });
    }, 800);

  }

  // Función para manejar si el usuario da enter y pasar al siguiente input
  keytab(event) {
    if (event.srcElement.id === 'idusr') {
      document.getElementById('psw').focus();
    }

    if (event.srcElement.id === 'psw') {
      if (this.user.username && this.user.password) {
        this.singUp();
      } else {
        return;
      }
    }
  }

  // Función para manejar la duración de las alertas
  durationMessage(label) {
    window.setTimeout(function () {
      $('.' + label).fadeTo(500, 1).slideUp(500, function () {
        $('.' + label).hide();
      });
    }, 3000);
  }

  //endregion

}
